import { cn } from '@workspace/ui/lib/utils'
import type { ReactNode } from 'react'

export interface SectionProps {
  /** Section title displayed in the header */
  title?: string
  /** Section content */
  children: ReactNode
  /** Additional CSS classes for the outer container */
  className?: string
  /** Whether this section should be hidden */
  hidden?: boolean
  /**
   * Scroll-dwell tracking key (a `PROFILE_VIEW_SECTION` value). Sections set
   * their own rather than taking it from the caller, so every surface reports
   * the same vocabulary. Must not be nested inside another marked element.
   */
  dataSection?: string
}

export function Section({ title, children, className, hidden = false, dataSection }: SectionProps) {
  if (hidden) return null

  return (
    <div
      data-section={dataSection}
      className={cn('border-b border-border px-4 py-4 lg:px-8 lg:py-5', className)}
    >
      {title && (
        <h3 className="mb-3 text-xs font-medium uppercase tracking-wider text-muted-foreground">
          {title}
        </h3>
      )}
      {children}
    </div>
  )
}
